<script lang="ts">
    import AppWraper from "../components/AppWraper.svelte";
    import RegisterModalDetained from "../components/RegisterModalDetained.svelte";
    import type { RecordsDetained } from "../Model/RecordsDetained";
    import { recordsDetainedService } from "../services";
    import { dateInputFormatter } from "../services/Functions";

    export let third_id: string
    let editRegister = null;
    let registers: any[];

    let newRegisters = false;

    $: loadRegisters();

    async function loadRegisters(): Promise<void> {

        registers = await recordsDetainedService.getRecordsByThird(third_id);
    }

    function registerUpdate(register: RecordsDetained): void {
        let registerAct = registers.find(u => u.id == register.id)

        if (registerAct) {
            registerAct = register
            registers = registers;
        }else{
            registers = [...registers, register];
        }
    }

</script>

<style>

</style>

{#if registers}
    <div class="row mt-3">
        <div class="col-12">
            {#if registers?.length}
            <table class="table">
                <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Entrada</th>
                            <th scope="col">Fecha Entrada</th>
                            <th scope="col">Salida</th>
                            <th scope="col">Fecha Salida</th>
                            <th scope="col">Delito</th>
                        </tr>
                </thead>
                <tbody>
                    {#each registers as register, index }
                        <tr>
                            <th scope="row">{index + 1}</th>
                            <td>
                                {#if register.inRegister}
                                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                                    <span class='btn btn-link' on:click={() => {editRegister = register; newRegisters = false}}>
                                        {register.inRegister}
                                    </span>
                                {/if}
                            </td>
                            <td>
                                {#if register.inDate}
                                    {dateInputFormatter(register.inDate)}
                                {/if}
                            </td>
                            <td>
                                {#if register.outRegister}
                                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                                    <span class='btn btn-link' on:click={() => {editRegister = register; newRegisters = false}}>
                                        {register.outRegister}
                                    </span>
                                {/if}
                            </td>
                            <td>
                                {#if register.outDate}
                                    {dateInputFormatter(register.outDate)}
                                {/if}
                            </td>
                            <td>
                                {#if register.crimeName}
                                    {register.crimeName}
                                {/if}
                            </td>
                        </tr>
                    {/each}
                </tbody>
            </table>
            {:else}
                <div class="text-center pt-5">
                    <hr>
                    <h4>No hay registros para mostrar</h4>
                </div>
            {/if}
        </div>
    </div>
{/if}
<RegisterModalDetained register={editRegister} bind:newRegister={newRegisters} on:registerUpdate={() => registerUpdate(editRegister)}/>